import { KFormUser } from "@components";
import { HospitalizationTypeOptions } from "@constants/options";
import { ECardType } from "@types";
import { Flex } from "antd";
import { AttachmentsDetail } from "./Attachments";
import { SetReminderSection } from "./SetReminderSection";

export const HospitalizationDetail = () => {
  return (
    <>
      <KFormUser.Select
        label="Type"
        name="type"
        options={HospitalizationTypeOptions}
      />
      <Flex gap={16} justify="space-between">
        <KFormUser.DatePicker label="Admitted Date" name="startTime" />
        <KFormUser.EndDatePicker label="Discharge Date" name="endTime" />
      </Flex>
      <KFormUser.OptionsSelector
        label="Practitioner"
        cardType={ECardType.Practitioners}
      />
      <KFormUser.TextArea
        label="Nurse(s)"
        name="nurse"
        placeholder="Enter nurse info"
      />
      <KFormUser.TextArea
        label="Location"
        name="location"
        placeholder="Enter location info"
      />
      <KFormUser.OptionsSelector
        label="Primary Related Condition"
        cardType={ECardType.Conditions}
      />
      <KFormUser.TextArea label="Additional Information" name="description" />
      <AttachmentsDetail />
      <SetReminderSection />
    </>
  );
};
